export default __webpack_public_path__ + "static/iossdk-e91ed43790fbbc5c4677ad23fe75e351.jpeg";